import React from 'react';

const Termspopup = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-lg space-y-6 text-sm md:text-base text-gray-700 ">
      <h2 className="text-2xl font-semibold text-[#3D6643]">Terms of Service </h2>

      <p>
        Welcome to Stay Cool! By accessing or using our vacation rental management and booking platform (“Stay Cool”), you agree to be bound by these Terms of Service (“Terms”). Please read them carefully.
      </p>

      <h3 className="text-lg font-semibold mt-4">1. Account Registration</h3>
      <p>
        To use Stay Cool’s services, users must create an account and provide accurate, up-to-date information. You are responsible for maintaining the confidentiality of your account credentials.
      </p>

      <h3 className="text-lg font-semibold mt-4">2. Booking Management</h3>
      <p>
        Stay Cool allows property owners to list and manage their rental properties and for guests to make reservations. All bookings are subject to availability and the individual property’s rules.
      </p>

      <h3 className="text-lg font-semibold mt-4">3. Payments and Fees</h3>
      <p>
        Stay Cool facilitates payments between hosts and guests. Fees may apply for transactions and are clearly indicated during the booking process. We are not liable for failed payments or unauthorized transactions.
      </p>

      <h3 className="text-lg font-semibold mt-4">4. Cancellations and Refunds</h3>
      <p>
        Cancellation policies are set by the property owners and are displayed on each listing. Refunds, if applicable, will be processed based on the host’s policy. Stay Cool is not responsible for disputes between guests and hosts.
      </p>

      <h3 className="text-lg font-semibold mt-4">5. Acceptable Use</h3>
      <p>
        Users agree not to misuse the platform or engage in fraudulent, harmful, or illegal activities. Stay Cool reserves the right to suspend or terminate accounts violating these rules.
      </p>

      <h3 className="text-lg font-semibold mt-4">6. Data and Privacy</h3>
      <p>
        We collect and use your personal data in accordance with our Privacy Policy. By using Stay Cool, you consent to the collection and use of your information as described.
      </p>

      <h3 className="text-lg font-semibold mt-4">7. Limitation of Liability</h3>
      <p>
        Stay Cool is not liable for any damages arising from use of the platform, including loss of data, revenue, or booking issues. We do not guarantee uninterrupted service.
      </p>

      <h3 className="text-lg font-semibold mt-4">8. Changes to Terms</h3>
      <p>
        Stay Cool reserves the right to update these Terms at any time. Continued use of the service after changes constitutes your acceptance of the updated Terms.
      </p>

      {/* <h3 className="text-lg font-semibold mt-4">9. Contact Us</h3> */}
      <p>
        {/* If you have questions about these Terms, please contact us at <a href="mailto:support@staycool.com" className="text-[#3D6643] underline">support@staycool.com</a>. */}
      </p>

      <p className="text-xs text-gray-500">
        Effective Date: July 26, 2025
      </p>
    </div>
  );
};

export default Termspopup;
